import React from 'react';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as action from '../../store/DevelopmentOrder.action';
import { customStyles } from '../../../../Components/helper';
import ImportedDataTableRow from './ImportedDataTableRow';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

const forIcons = (sortTable, iconsChange) => {
  return sortTable.propertyName === 'description' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />;
};

function ImportedDataTable({
  handleSelectAll,
  isSelectAll,
  allImportedTest,
  onSortColumn,
  isLoading,
  iconsChange,
  sortTable,
  isSupplierLoggedIn,
  isProductArchived,
  onSelectCheckBox,
  selectedIdArray,
  selectedBom,
  selectedColour,
  selectedSupplier,
  showNewRow,
  handleCancle,
  showData,
  showParentData,
  handleDelete,
  hanldeUpdate,
  fromTestLib,
  fromProductBom,
  fromProductTesting,
}) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets } = ProductTestingData;
  const { productRefs, productRef_bom } = Measuremets;

  const ifOneSelectedBom = () => {
    return !isEmpty(selectedBom) ? selectedBom?._id : null;
  };

  const newArrayShow = () => {
    const forFilteredOptions = () => {
      return fromTestLib && !isEmpty(productRef_bom) ? [...productRef_bom] : fromProductRefs();
    };

    const fromProductRefs = () => {
      return fromProductTesting ? [...productRefs.filter((eles) => eles._id !== devOrderId)] : [...productRefs];
    };

    const productRefrences = () => {
      return productRef_bom && Array.isArray(productRef_bom) ? [...productRef_bom] : [productRef_bom];
    };

    return (
      showNewRow && (
        <tr>
          <td />
          <td className="first-fix-col increse-z">
            <div className="document-title">
              <div className="custom-react-select">
                <Select
                  name="selectedEntery"
                  options={!fromTestLib && selectedBom ? productRefrences() : forFilteredOptions()}
                  maxMenuHeight={132}
                  menuPosition="fixed"
                  menuPlacement="bottom"
                  getOptionLabel={(option) => (!option.description ? option.number : `${option.number}-${option.description}`)}
                  getOptionValue={(option) => `${option._id}`}
                  styles={customStyles}
                  className="common-select"
                  classNamePrefix="common-select"
                  onChange={(e) => handleSelectedOption(e)}
                  placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.PRODUCT_REF')}
                />
              </div>
            </div>
          </td>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td className="last-fix-col" />
          <td />
          <td />
          <td>
            <div className="table-action-container">
              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CANCEL')}>
                <button
                  type="button"
                  className="btn p-0"
                  onClick={() => handleCancle()}
                  aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CANCEL')}
                >
                  <span className="icon icon-close f-20" />
                </button>
              </CustomTooltip>
            </div>
          </td>
        </tr>
      )
    );
  };

  const handleSelectedOption = async (e) => {
    if (showData && e) {
      const paramsforSelection = {
        devOrderId: e._id,
        testLibId: showData._id,
        bomComponent: fromProductBom ? showParentData?._id : ifOneSelectedBom(),
        colour: !isEmpty(selectedColour) ? selectedColour?._id : null,
        supplier: !isEmpty(selectedSupplier) ? selectedSupplier?._id : null,
        isBomLibrary: fromProductBom,
      };
      if (fromProductTesting) {
        await dispatch(action.addTestToProduct(paramsforSelection, t));
      } else {
        await dispatch(action.PostFromAttri(paramsforSelection, t));
      }
      await handleCancle();
    }
  };

  const tableData = (testItem, testIndex) => {
    return (
      <ImportedDataTableRow
        item={testItem}
        i={testIndex}
        isSupplierLoggedIn={isSupplierLoggedIn}
        isProductArchived={isProductArchived}
        onSelectCheckBox={onSelectCheckBox}
        selectedIdArray={selectedIdArray}
        handleDelete={handleDelete}
        hanldeUpdate={hanldeUpdate}
        bomComponent={showParentData ? showParentData?.referenceCode : selectedBom}
        componentSupplier={selectedSupplier}
        colourRef={selectedColour}
      />
    );
  };

  const ifNoData = () => {
    return (
      !isLoading &&
      allImportedTest &&
      isEmpty(allImportedTest) &&
      !showNewRow && (
        <tr>
          <td className=" text-center" colSpan="19">
            <h6>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.NO_TESTING_REQ_FOUND')}</h6>
          </td>
        </tr>
      )
    );
  };

  const ifData = () => {
    return (
      !isLoading &&
      allImportedTest &&
      !isEmpty(allImportedTest) &&
      allImportedTest.map((testItem, testIndex) => {
        return tableData(testItem, testIndex);
      })
    );
  };

  const ifProductRefNumber = () => {
    return sortTable.propertyName === 'number' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />;
  };

  return (
    <div className="table-responsive mb-3" id="test-requirment">
      <table className="table common-custom-table m-0" id="test-requirment">
        <thead>
          <tr>
            <th className="w-50px">
              <div className="common-checkbox no-label checkbox-center">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  name="checking_all"
                  id="checking_all"
                  checked={isSelectAll}
                  disabled={isEmpty(allImportedTest)}
                />
                <label htmlFor="checking_all" className="chklabel" />
              </div>
            </th>
            <th
              className="w-230px first-fix-col"
              onClick={() => {
                onSortColumn('number');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.PRODUCT_REFERENCE')}
                {ifProductRefNumber()}
              </span>
            </th>
            <th
              className="w-230px"
              onClick={() => {
                onSortColumn('description');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.PRODUCT_DESCRIPTION')}
                {forIcons(sortTable, iconsChange)}
              </span>
            </th>
            <th
              className="w-230px"
              onClick={() => {
                onSortColumn('suppliers');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.PRODUCT_SUPPLIER')}
                {sortTable.propertyName === 'suppliers' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('compSupplier');
              }}
            >
              <span className="d-flex align-items-center cursor-pointer">
                <span style={{ flex: '0 0 80px' }}>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.COMPONENT_SUPPLIER')}</span>
                {sortTable.propertyName === 'compSupplier' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-120px"
              onClick={() => {
                onSortColumn('brand');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.BRAND')}
                {sortTable.propertyName === 'brand' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-120px"
              onClick={() => {
                onSortColumn('season');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.SEASON')}
                {sortTable.propertyName === 'season' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-120px"
              onClick={() => {
                onSortColumn('month');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.MONTH')}
                {sortTable.propertyName === 'month' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-120px"
              onClick={() => {
                onSortColumn('year');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.YEAR')}
                {sortTable.propertyName === 'year' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('catOne');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CATEGORY_1')}
                {sortTable.propertyName === 'catOne' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('catTwo');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CATEGORY_2')}
                {sortTable.propertyName === 'catTwo' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('catThree');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CATEGORY_3')}
                {sortTable.propertyName === 'catThree' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('catFour');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CATEGORY_4')}
                {sortTable.propertyName === 'catFour' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('testingReports');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.TESTING_REPORTS')}
                {sortTable.propertyName === 'testingReports' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('BomComp');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.BOM_COMPONENET')}
                {sortTable.propertyName === 'BomComp' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px last-fix-col"
              onClick={() => {
                onSortColumn('colours');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.COLOR_REF')}
                {sortTable.propertyName === 'colours' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-150px"
              onClick={() => {
                onSortColumn('currentStatus');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.CURRENT_STATUS')}
                {sortTable.propertyName === 'currentStatus' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th
              className="w-120px"
              onClick={() => {
                onSortColumn('isMatch');
              }}
            >
              <span className="d-flex cursor-pointer">
                {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_DATA_TABLE.DATA_MATCH')}
                {sortTable.propertyName === 'isMatch' ? iconsChange() : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
            <th className="w-150px" />
          </tr>
        </thead>
        <tbody>
          {newArrayShow()}
          {ifNoData()}
          {ifData()}
        </tbody>
      </table>
    </div>
  );
}

export default ImportedDataTable;
